import React from 'react';
import { Helmet } from 'react-helmet-async';

interface SEOHeadProps {
  title: string;
  description: string;
  path: string;
  type?: string;
  image?: string;
}

export const SEOHead: React.FC<SEOHeadProps> = ({ 
  title, 
  description, 
  path,
  type = 'website',
  image = 'https://ziyrlqyuwnxpkliapfnt.supabase.co/storage/v1/object/public/images/WiseRank/wiserank.png' // Default OG image
}) => {
  const baseUrl = 'https://wiserank.ai';
  const url = `${baseUrl}${path}`;

  return (
    <Helmet>
      {/* Basic Meta Tags */}
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={url} />
      <meta name="robots" content="index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1" />

      {/* Open Graph */}
      <meta property="og:type" content={type} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta property="og:site_name" content="WiseRank.ai" />
      <meta property="og:image" content={image} />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />
      <meta property="og:locale" content="fr_FR" />
      <meta property="og:locale:alternate" content="en_US" />

      {/* Twitter Card */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />

      {/* Language Alternates */}
      <link rel="alternate" href={url} hrefLang="fr-fr" />
      <link rel="alternate" href={`${url}/en`} hrefLang="en-us" />
      <link rel="alternate" href={url} hrefLang="x-default" />
    </Helmet>
  );
};